if (!customElements.get("back-in-stock-form")) {
  class BackInStockForm extends HTMLElement {
    constructor() {
      super();

      this.variantSelect = this.querySelector(".back-in-stock-form__variant");
      this.emailInput = this.querySelector(".back-in-stock-form__email");
      this.submitButton = this.querySelector(".back-in-stock-form__submit");
      this.invalidEmailMessage = this.dataset.invalidEmail;
      this.klaviyoCompanyId = this.dataset.klaviyoCompanyId;
      this.acceptsMarketingInput = this.querySelector(
        "input.back-in-stock-form__consent-checkbox",
      );
      this.acceptsMarketingLabel = this.querySelector(
        ".back-in-stock-form__consent-label",
      );

      this.listId = "Xdu4V6";

      if (window.Shopify.locale.toLowerCase().includes("de")) {
        this.listId = "VzXBep";
      }

      // The form is rendered as the content of the generic modal, which owns
      // open/close. Reset back to the form view whenever the modal opens.
      this.modal = this.closest("custom-modal");
      this.modal?.addEventListener("modal:show", () => this.reset());

      this.submitButton.addEventListener("click", async () => {
        const variantId = this.variantSelect.value;
        const email = this.emailInput.value;

        if (email == "" || email == null) {
          alert(this.invalidEmailMessage);
          return;
        }

        if (!this.acceptsMarketingInput.checked) {
          this.acceptsMarketingLabel.classList.add(
            "back-in-stock-form__consent-label--invalid",
          );
          return;
        }

        const klaviyoSuccess = await this.pushKlaviyoBackInStock(
          variantId,
          email,
        );
        console.log(
          "Registered BackInStock Klaviyo. Klaviyo response: " + klaviyoSuccess,
        );
        this.setAttribute("data-state", "success");
        this.variantSelect.setAttribute("disabled", "true");
        this.emailInput.setAttribute("disabled", "true");
      });
    }

    reset() {
      this.setAttribute("data-state", "form");
      this.variantSelect.removeAttribute("disabled");
      this.emailInput.removeAttribute("disabled");
      this.acceptsMarketingInput.checked = false;
      this.acceptsMarketingLabel.classList.remove(
        "back-in-stock-form__consent-label--invalid",
      );
      setTimeout(() => {
        this.emailInput.focus();
      }, 300);
    }

    async createSubscription(email) {
      const urlParams = new URLSearchParams();
      urlParams.set("company_id", this.klaviyoCompanyId);
      const profileAttributes = {
        email,
      };

      const body = {
        data: {
          type: "subscription",
          attributes: {
            custom_source: "back_in_stock_form",
            profile: {
              data: {
                type: "profile",
                attributes: profileAttributes,
              },
            },
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: this.listId,
              },
            },
          },
        },
      };

      const options = {
        method: "POST",
        headers: {
          revision: "2026-04-15",
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
        },
        body: JSON.stringify(body),
      };

      const klaviyoFetch = await fetch(
        "https://a.klaviyo.com/client/subscriptions?" + urlParams.toString(),
        options,
      );

      return klaviyoFetch.ok;
    }

    async subscribeBackInStock(variantId, email) {
      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email,
                },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: "$shopify:::$default:::" + variantId,
              },
            },
          },
        },
      };

      var requestOptions = {
        method: "POST",
        headers: {
          revision: "2026-04-15",
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
        },
        body: JSON.stringify(payload),
      };

      const urlParams = new URLSearchParams();
      urlParams.set("company_id", this.klaviyoCompanyId);

      const fetchRes = await fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions?" +
          urlParams.toString(),
        requestOptions,
      );
      return fetchRes.ok;
    }
    async pushKlaviyoBackInStock(variantId, email) {
      const backInStockSubscribeStatus = await this.subscribeBackInStock(
        variantId,
        email,
      );
      await this.createSubscription(email);

      return backInStockSubscribeStatus;
    }
  }
  customElements.define("back-in-stock-form", BackInStockForm);
}
